exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\n  PKA - dealSuccessTicket\n */\n\n.myPerksTicket-dialog .modal-content {\n    background: none;\n    box-shadow: none;\n    border: none;\n    margin-top: 100px;\n}\n\n.myPerksTicket {\n    box-sizing: border-box;\n    height: 15px;\n    width: 15px;\n    font-weight: 100;\n    font-size: 30px;\n    position: relative;\n    top: 40px;\n    right: -80%;\n    padding: 10px;\n    z-index: 1;\n}\n.myPerksTicket:hover {\n    text-decoration: none;\n    color: black;\n}\n", ""]);

// exports
